import moment from 'moment'

const service = {}

service.getYearsAvailable = function () {
  const YEARS_OLD = 70
  const currentYear = moment().year()
  const lastYear = currentYear - YEARS_OLD

  const listYears = []

  for (let i = currentYear; i >= lastYear; i--) {
    listYears.push(i)
  }

  return listYears;
}

service.getColors = function () {
  return [
    "Blanco",
    "Negro",
    "Gris",
    "Dorado",
    "Café",
    "Tinto",
    "Rojo",
    "Azul",
    "Amarillo",
    "Naranja",
    "Verde",
    "Morado",
    "Otro",
  ]
}

export default service
